<template>
  <el-autocomplete 
    v-model="inputValue"
    :placeholder="placeholder"
    :readonly="readonly"
    :disabled="disabled"
    :value-key="labelKey"
    size="small"
    :fetch-suggestions="querySearch"
    @select="handleSelect"
    @change="handlerChange"
  >
    <template slot-scope="{ item }">
      <slot :item="item" />
    </template>
  </el-autocomplete>
</template>
<script>
export default {
  name: 'VAutocomplete',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => ([])
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    valueKey: {
      type: String,
      default: 'id'
    }
  },
  data() {
    return {
      inputValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if(this.inputValue !== val) {
          this.inputValue = String(val)
        }
      }
    },
    inputValue(val) {
      this.$emit('input', String(val))
    }
  },
  methods: {
    querySearch(queryString, cb) {
      let list = this.list.slice(0) // 深拷貝數組
      let results = queryString? list.filter(item => {
        return String(item[this.labelKey]).toLowerCase().indexOf(queryString.toLowerCase()) !== -1
      }) : list
      cb(results)
    },
    handleSelect(item) {
      this.$emit('select', item)
    },
    handlerChange(v) {
      // console.log(v)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-autocomplete {
    width: 100%;
}
</style>
